import React, { useState } from 'react';
import { Button, Typography, Paper, Grid } from '@mui/material';
import CollapsibleText from './CollapsibleText';

const RowDetails = ({ row, onClose }) => {
  const [expandedFields, setExpandedFields] = useState({});

  if (!row) return null;

  // Format keys for labels
  const formatKey = (key) =>
    key.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

  // Toggle expand/collapse for a specific key
  const toggleExpand = (key) => {
    setExpandedFields((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <Paper
      elevation={3}
      sx={{
        marginTop: '20px',
        padding: '20px',
        borderRadius: '8px',
        background: '#ffffff',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        maxWidth: '800px',
        marginLeft: 'auto',
        marginRight: 'auto',
      }}
    >
      {/* Header Section */}
      <Typography
        variant="h6"
        sx={{
          marginBottom: '20px',
          fontWeight: 'bold',
          textAlign: 'center',
        }}
      >
        Row Details
      </Typography>

      {/* Details Content */}
      <Grid container spacing={2}>
        {Object.entries(row).map(([key, value]) => {
          const isExpanded = expandedFields[key] || false;
          const maxLength = 200; // Max length for truncation
          const isLongText = value && value.length > maxLength; // Check if text exceeds max length

          return (
            <Grid
              container
              item
              xs={12}
              key={key}
              sx={{
                alignItems: 'flex-start',
                borderBottom: '1px solid #ddd',
                paddingBottom: '10px',
                marginBottom: '10px',
              }}
            >
              {/* Label Column */}
              <Grid item xs={4}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 'bold',
                    textAlign: 'right',
                    paddingRight: '10px',
                  }}
                >
                  {formatKey(key)}:
                </Typography>
              </Grid>

              {/* Value Column */}
              <Grid item xs={8}>
                {/* Collapsible Text Box */}
                <CollapsibleText
                  text={value}
                  maxLength={maxLength}
                  expanded={isExpanded}
                />

                {/* Toggle Button - Only Show if Text is Long */}
                {isLongText && (
                  <Button
                    size="small"
                    onClick={() => toggleExpand(key)}
                    sx={{
                      marginTop: '8px',
                      textTransform: 'none',
                      fontWeight: 'bold',
                    }}
                  >
                    {isExpanded ? 'Show Less' : 'Show More'}
                  </Button>
                )}
              </Grid>
            </Grid>
          );
        })}
      </Grid>

      {/* Close Button */}
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <Button variant="contained" color="primary" onClick={onClose}>
          Close
        </Button>
      </div>
    </Paper>
  );
};

export default RowDetails;